



















import {
	defineComponent, PropType,
} from '@vue/composition-api';
import { Size, Spacing } from '@front-app/components/constants';
import { EventManagementData } from '@front-app/services/EventsApi/EventModel';
import { syncedRef } from '@front-app/util/reactivity';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import CategoriesInput from '@front-app/components/inputs/CategoriesInput.vue';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import {
	EVENT_TOPIC_KEYS,
	EVENT_API_STRINGS_TO_TOPIC_KEY,
	EVENT_TOPIC_KEYS_TO_API_STRING,
} from '@front-app/modules/event/components/eventTopics';
import { isNotNullish } from '@front-app/util/types';
import EditEventBaseForm from './EditEventBaseForm.vue';
import { useEventAdminStore } from '../../store/EventAdmin';

export default defineComponent({
	components: {
		CategoriesInput,
		EditEventBaseForm,
	},
	props: {
		eventData: {
			type: Object as PropType<EventManagementData>,
			required: true,
		},
	},
	setup(props, ctx) {
		const selectedCategories = syncedRef(() => props.eventData.categories
			.map((val) => EVENT_API_STRINGS_TO_TOPIC_KEY[val])).ref;
		const removeSelectedCategory = (val: string) => {
			selectedCategories.value = selectedCategories.value.filter((_) => _ !== val);
		};

		const {
			track,
			isLoading: isSavingUpdates,
			isError: isErrorSavingUpdates,
			isSuccess: isSuccessSavingUpdates,
		} = useAsyncStatus();

		const saveUpdates = async () => {
			await track(useEventAdminStore().update(
				props.eventData.id,
				{ categories: selectedCategories.value.map((val) => EVENT_TOPIC_KEYS_TO_API_STRING[val]).filter(isNotNullish) },
			));

			if (isSuccessSavingUpdates.value) {
				ctx.emit('close');
			}
		};

		return {
			selectedCategories,
			removeSelectedCategory,
			EVENT_TOPIC_KEYS,
			isSavingUpdates,
			isErrorSavingUpdates,
			saveUpdates,
			// Util
			Size,
			Spacing,
			ButtonPalettes,
		};
	},
});
